module.exports = __webpack_public_path__ + "static/google-play-light-44e435717693e3fdafccfd2107faa29f.svg";